module.exports = __webpack_public_path__ + "img/suriname.066c1f33.svg";